const IconWithBadge = ({ Icon, count, show, onClick }) => (
  <div className="relative">
    <Icon
      className="w-6 h-6 text-white hover:text-white/80 cursor-pointer transition-colors duration-200"
      onClick={onClick}
    />
    {count > 0 && (
      <span
        className={`
        absolute -top-2 -right-2 
        bg-red-500 text-white 
        text-xs font-bold 
        w-5 h-5 
        flex items-center justify-center 
        rounded-full
        transform
        transition-all duration-300
        ${show ? "scale-100 opacity-100" : "scale-0 opacity-0"}
      `}
      >
        {count}
      </span>
    )}
  </div>
);

export default IconWithBadge;
